import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
import { TableLinkMLStyled } from './TableLinkMLStyled.js';
import styles from './tableLinkML.less?modules';
const TableLinkML = (props) => {
  const { handleClick = () => {}, text = '' } = props;
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  return (
    <TableLinkMLStyled
      theme={themeContext}
      brand={brandContext}
      className={styles.table_link}
    >
      <div className="name" onClick={handleClick}>
        {text}
      </div>
    </TableLinkMLStyled>
  );
};
export default TableLinkML;
